/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import bgImage from "../../assets/images/img-bg-full-apply.jpg";
import { Blank, Div, EvButton, Font, Form, Input, Row, Span, CheckBox } from "../../styles/commonStyle";
import { cardTitleColor, fontColor, modalGreyBtnColor, noticeRedColor, orangeBtnGradient, primaryColor, redColor } from "../../styles/theme";
import { findChargerQrSelector, showChargerRecordSelector, stipulation1Selector } from "../../recoil/variableAtom";
import { useEffect, useState } from "react";
import { RESULT, ResponseModel } from "../../model/response";
import useFetch from "../../hooks/useFetch";
import { Charger } from "../../model/charger";
import Loading from "../../components/loading/loading";
import { Select, SocContainer, SocContent, Title } from "./style";
import { RoundButton } from "../../components/modal/style";
import { SocModel } from "../../model/soc";
import EvModal from "../../components/modal";
import { useRecoilState } from "recoil";
import { alertState, modalState } from "../../recoil/atoms";
import EvAlert from "../../components/modal/evAlert/evAlert";
import cationIcon from "../../assets/images/cation.png";
import { _instance, APILIST, request } from "../../repository/api";
import { AxiosResponse } from "axios";
import { Stipulation } from "../../model/stipulation";
import TermsSoc from "./components/termsSoc";
import { stipulationSOCSelector } from "../../recoil/variableAtom";

function SocPage() {
    const params = useParams();
    const chargerId = params.chargerId;
    const [alertOpen, setAlertOpen] = useRecoilState(alertState);
    const [alertMsg, setAlertMsg] = useState<string>('');
    const [getQuery, setQuery] = useState<any>();
    const [isLoading, setLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [isInitialLoading, setIsInitialLoading] = useState(true);
    const [socData, setSocData] = useState<SocModel>();
    const [selectedSoc, setSelectedSoc] = useState<string>('none');
    const [remainingTime, setRemainingTime] = useState<number>(0);
    const response: ResponseModel<SocModel> = useFetch({
        recoilSelector: showChargerRecordSelector,
        query: getQuery,
    });
    
    // 약관 관련
    const stipulationResponse: ResponseModel<Stipulation> = useFetch({
        recoilSelector: stipulationSOCSelector,
    });
    
    const [reload, setReload] = useState(false);
    const [openIdx, setOpenIdx] = useState<number>(-1);
    const [term01, setTerm01] = useState<string>('');
    const [isTermsAgreed, setIsTermsAgreed] = useState<boolean>(false);

    // 충전내역 조회
    useEffect(() => {
        if (chargerId) {
            setQuery(chargerId);
        }
    }, []);

    // 약관 데이터 가져오기
    useEffect(() => {
        if (stipulationResponse?.result === RESULT.OK) {
            setTerm01(stipulationResponse.data?.cn || '');
        }
    }, [stipulationResponse]);

    // 충전내역 조회 결과 처리
    useEffect(() => {
        if (!getQuery) {
            return;
        }
        if (response?.result === RESULT.OK) {
            setIsSuccess(true);
            setSocData(response.data);
            const expireTime = new Date(response.data?.expire_dt || '');
            const currentTime = new Date();
            if (currentTime > expireTime) {
                setIsSuccess(false);
            }
        }
        if (response?.result === RESULT.FAIL) {
            setSocData(undefined);
        }
        setIsInitialLoading(false);
    }, [response]);

    // 만료시간 지정
    useEffect(() => {
        if (!response?.data?.expire_dt) return;

        const expireTime = new Date(response.data?.expire_dt || '');
        const interval = setInterval(() => {
            const currentTime = new Date();
            const timeDiff = Math.floor((expireTime.getTime() - currentTime.getTime()) / 1000);
            setRemainingTime(timeDiff > 0 ? timeDiff : 0);

            if (currentTime > expireTime) {
                setIsSuccess(false);
                clearInterval(interval);
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [response]);

    // 목표 충전율 변경
    const onSubmitHandler = async () => {
        setLoading(true);
        if (selectedSoc === 'none') {
            setAlertMsg('목표 충전율을 선택해주세요.');
            setAlertOpen(true);
            setLoading(false);
            return;
        }
        
        var data = {
            chrgr_idntfr: socData?.chrgr_idntfr,
            cnnctr_id: socData?.cnnctr_id?.toString(),
            transaction_id: socData?.transaction_id,
            soc: parseInt(selectedSoc),
            smart_control_privacy_yn: isTermsAgreed ? 'Y' : 'N',
        }
        var res: AxiosResponse<ResponseModel<any>>;
        try {
            res = await _instance.post(APILIST.QR_SET_CHARGING_TARGET, data, { timeout: 3000 });
        } catch (error: any) {
            setLoading(false);
            if (error.code === 'ECONNABORTED') {
                setAlertMsg('서버 응답이 지연되고 있습니다.\n잠시 후 다시 시도해주세요.');
                setAlertOpen(true);
            } else {
                setAlertMsg('요청 중 오류가 발생했습니다.\n잠시 후 다시 시도해주세요.');
                setAlertOpen(true);
            }
            return;
        }
        setLoading(false);
        if (res!.data.result === RESULT.OK) {
            setAlertMsg(res!.data.msg || '');
            setAlertOpen(true);
        }
        if (res!.data.result === RESULT.FAIL) {
            setAlertMsg(res!.data.msg || '');
            setAlertOpen(true);
        }
        setReload(true);
    };


    return (
        <>
            {
                isInitialLoading ? <Loading isLoading={true} /> :
                    !isSuccess ? <SocContainer>
                        <img src={cationIcon} alt="" style={{ width: "60px", margin: "24px auto" }} />
                        <Font fontSize="18px" fontWeight="500" color={cardTitleColor} style={{ margin: "0 auto", textAlign: "center" }}>
                            충전기 정보를 찾을 수 없습니다.
                        </Font>
                        <Font fontSize="14px" fontWeight="400" color={fontColor} style={{ margin: "16px auto", textAlign: "center" }}>
                            충전기가 충전중인 상태가 아니거나<br />
                            QR 코드의 유효 시간이 만료되었습니다.
                        </Font>
                    </SocContainer> :
                        <SocContainer>
                            <Title>목표 충전율 설정</Title>
                            <SocContent>
                                <Font fontSize="14px" fontWeight="400" color={cardTitleColor}>
                                    * 충전율을 선택해 주세요.
                                </Font>
                            </SocContent>
                            <SocContent>
                                <Div style={{ width: "125px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                    <Font fontSize="14px" fontWeight="400" color={cardTitleColor}>
                                        현재 목표 충전율
                                    </Font>
                                    <Font fontSize="14px" fontWeight="400" color={cardTitleColor}>
                                        =
                                    </Font>
                                </Div>
                                <Font fontSize="16px" fontWeight="500" color={cardTitleColor}>
                                    {socData?.target_soc ? `${socData?.target_soc}%` : '선택없음'}
                                </Font>
                            </SocContent>
                            <SocContent>
                                <Div style={{ flexShrink: 0, width: "125px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                    <Font fontSize="14px" fontWeight="400" color={cardTitleColor}>
                                        변경할 목표 충전율
                                    </Font>
                                    <Font fontSize="14px" fontWeight="400" color={cardTitleColor}>
                                        =
                                    </Font>
                                </Div>
                                <Select value={selectedSoc} onChange={(e) => {
                                    setSelectedSoc(e.target.value);
                                }}>
                                    <option value="none" defaultValue={'none'}>선택없음</option>
                                    <option value="100">100%</option>
                                    <option value="90">90%</option>
                                    <option value="80">80%</option>
                                    <option value="70">70%</option>
                                    <option value="60">60%</option>
                                    <option value="50">50%</option>
                                </Select>
                                <RoundButton onClick={() => onSubmitHandler()} width="70px" height="40px" fill={true} style={{ flexShrink: 0, fontSize: "14px" }}>저장</RoundButton>
                            </SocContent>
                            <Div style={{ width: "100%", display: "flex", justifyContent: "flex-end", marginTop: "10px", marginBottom: "10px" }}>
                                {
                                    remainingTime > 0 ?
                                        <Font fontSize="14px" fontWeight="400" color={redColor}>남은 시간 : {remainingTime}초</Font> :
                                        null
                                }
                            </Div>

                            {/* 약관 섹션 추가 */}
                            <TermsSoc
                                termsContent={term01}
                                isChecked={isTermsAgreed}
                                onCheckChange={setIsTermsAgreed}
                                title="(선택) 스마트충전기 배터리 정보 제3자 제공"
                            />
                        </SocContainer>
            }
            <EvAlert msg={alertMsg} onConfirm={reload ? () => {
                window.location.reload();
            } : undefined} />
            <Loading isLoading={isLoading} />
        </>
    );
}

export default SocPage;
